module.exports = __webpack_public_path__ + "img/icon-red.e3425641.svg";